import { render, staticRenderFns } from "./DiagTasks.vue?vue&type=template&id=5f5cc010&scoped=true&"
import script from "./DiagTasks.vue?vue&type=script&lang=ts&"
export * from "./DiagTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5cc010",
  null
  
)

export default component.exports